import axios from 'axios'
import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import '../styles/Courses.css'

export default class Courses extends Component {
    constructor(props) {
        super(props)
    
        this.state = {
            courses : []
        }
    }
    
    componentDidMount() {
        axios.get('../js/Data.json').then((res) => {this.setState({
            courses : res.data.courses
        })})
    }
    render() {
        const {courses} = this.state
        const course = courses.map((courseItem) => {
            return (
                <div className="col-md-3 col-6" key={courseItem.ID}>
                    <div className="course-card text-center">
                    <h5 className="course-title text-left"><i class="fas fa-arrow-right"></i> {courseItem.course_title}</h5>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="course-img">
                                <img src={courseItem.image} alt="course img"/>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <ul className="list-unstyled text-left">
                                <li className="category"><i class={courseItem.icon_class1}></i> {courseItem.category}</li>
                                <li className="branch"><i class={courseItem.icon_class2}></i> {courseItem.branch}</li>
                            </ul>
                        </div>
                        <div className="col-md-6">
                            <ul className="list-unstyled text-left">
                                <li className="time"><i class={courseItem.icon_class3}></i> {courseItem.hours}</li>
                                <li className="branch"><i class={courseItem.icon_class4}></i> Lectures : {courseItem.lectures}</li>
                            </ul>
                        </div>
                    </div>
                    <hr/>
                    <Link to="/CourseDetails" className="view details"><i class="fas fa-info-circle"></i> {courseItem.details}</Link>
                    <button className="view later"><i class="fas fa-list"></i> {courseItem.prefer}</button>
                    </div>
                </div>
            )
        })
        return (
            <>
                <div className="courses pd">
                    <div className="container">
                        <h3 className="title">Courses</h3>
                        <div className="row">
                            {course}
                        </div>
                        <div className="text-center"><a className="more">More courses <i className="fas fa-angle-right"></i></a></div>
                    </div>
                </div>
            </>
        )
    }
}
